// eslint-disable-next-line import/prefer-default-export
export const getViewMode = ({ config }) => config.mode;
export const getContentOverlayDisplayState = ({ config }) => config.showContentOverlay;
export const getAppOverlayDisplayState = ({ config }) => config.showAppOverlay;
export const getAppEntitiesScrollDisplayState = ({ config }) => config.isScrollable;
export const getAppPointerEventsDisabledState = (store) => Object.keys(store).filter((key) => key !== 'suggestedItems').some((storeProperty) => {
  return (typeof store[storeProperty].loading === 'undefined' ? false : store[storeProperty].loading === true);
});
